import moment from 'moment'
import 'moment/locale/ro'

moment.locale('ro')

export const formatRomanianDate = (isoDate, format = 'DD MMMM YYYY') => {
  if (!isoDate) return ''

  const formatted = moment(isoDate).format(format)
  return formatted.charAt(0).toUpperCase() + formatted.slice(1)
}

export const formatShortDate = (isoDate) => {
  return formatRomanianDate(isoDate, 'DD MMM YYYY')
}

export const formatDateWithTime = (isoDate) => {
  return formatRomanianDate(isoDate, 'DD MMMM YYYY, HH:mm')
}
